import React, { useState, useEffect } from 'react'
import Managebtn from '../../Component/Managebtn'
import InvoiceForm from './InvoiceForm'
import InvoiceForm2 from "./invoiceForm2/InvoiceForm2"
import BackArrow from '../../Component/BackArrow/BackArrow'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../../Providers/LanguageContext'
import { AiOutlineAlignLeft, AiOutlineArrowLeft } from 'react-icons/ai'

function CreateInvoice() {
    const [time, setTime] = useState("day")
    const { language } = useLanguage();
    const navigate = useNavigate()
    const getTime = (val) => {
        setTime(val)
    }
    useEffect(() => {
        window.scrollTo({ top: '0', behavior: 'instant' })
    }, [])
    return (
        <>
            {/* <div className="try_fisibilty_wrapper " style={{
                transform: 'translateY(0%)',
                margin: '0px',
                justifyContent: 'start',
                background: '#031f31ff'

            }}>
                <div className="container-fluid">
                    <p className="text-left">Invoice Manager / Create & Send Invoice</p> </div>
            </div> */}
            <div style={{
                background: 'linear-gradient(rgba(15, 36, 55, 1), rgb(255, 255, 255))',
                padding: '20px 0px'
            }}>
                <div className='container-fluid' >
                    <div className='task_head'>Create Invoice</div>
                </div>
                <div className='container-fluid '>
                    <div className='d-flex justify-content-start align-items-center gap-2 container-fluid' >
                        {/* <div style={{
                            fontSize: '20px',
                            color: '#fff'
                        }}>
                            <BackArrow />
                        </div> */}
                        <div className='mt-3'>
                            <button className=' mb-2 slctUser' style={{
                                background: 'rgb(136, 233, 132)',
                                fontWeight: '500',
                                color: '#0c2637',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                                onClick={() => navigate('/view-invoice')}>


                                     <AiOutlineArrowLeft />

                                {language.view_invoice}
                            </button>
                        </div>
                    </div>
                </div>
                <div className='container-fluid' style={{
                    border: '4px solid #fff',
                    marginBottom: '40px',
                    borderRadius: '25px',
                    marginTop: '10px',
                    padding: '40px 20px'

                }}>

                    <Managebtn getTime={getTime} value={time} />
                    <InvoiceForm2 getTime={getTime} value={time} />
                </div>


                {/* <InvoiceForm time={time} /> */}

            </div>


        </>
    )
}

export default CreateInvoice